import React, { useEffect } from 'react'
import {
  func,
  bool,
  string,
} from 'prop-types'
import { useInView } from 'react-cool-inview'

const defaultClass = 'col-6 col-md-4 col-lg-3 col-xxl-2'

function ItemTracker({
  handleImpression,
  isTrackingEnabled,
  classNames = defaultClass,
  children
}) {
  const { observe, inView } = useInView({
    threshold: 0.7, // only count 70% visible item for impression.
    onEnter: ({ unobserve }) => {
      unobserve() // unobserve to avoid multiple impressions on same item.
    },
  })

  useEffect(() => {
    if (isTrackingEnabled && inView) {
      handleImpression()
    }
  }, [isTrackingEnabled, inView])

  return (
    <div className={classNames || defaultClass} ref={observe}>
      {children}
    </div>
  )
}

ItemTracker.propTypes = {
  handleImpression: func.isRequired,
  isTrackingEnabled: bool.isRequired,
  classNames: string,
}

export { ItemTracker }
